class HunterBadgeTooltip {
constructor() {
  this.init();
}

init() {
  const badges = document.querySelectorAll('.hunter-badge');
  
  badges.forEach(badge => {
    badge.addEventListener('mouseenter', (e) => {
      const title = badge.getAttribute('data-title');
      if (!title) return;

      const tooltip = document.createElement('div');
      tooltip.className = 'hunter-badge-tooltip';
      tooltip.textContent = title;
      
      badge.appendChild(tooltip);
    });

    badge.addEventListener('mouseleave', () => {
      const tooltip = badge.querySelector('.hunter-badge-tooltip');
      if (tooltip) {
        tooltip.remove();
      }
    });
  });
}
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new HunterBadgeTooltip();
});